/*
 * file: Routes.jsx
 * 상세: 인증 여부에 따라 경로 지정
 */

import { Fnc } from "common/globals"
import { authRoutes, unAuthRoutes } from "routes/AllRoutes";

export default function Routes() {

  document.body.classList.add('bd_bg');

  // 유저 로그인 체크
  if (Fnc.CheckUser()) {
    return authRoutes 
  } else {
    return unAuthRoutes
  }
}